var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loginPage)?_c('v-icon',{attrs:{"color":"white"},on:{"click":_vm.logout}},[_vm._v("power_settings_new")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }